import React, { useState } from "react";
import { Container } from "react-bootstrap";
import LeftNavbar from "../components/LeftNavbar";
import TopHeader from "../components/TopHeader";
import StepOne from "./ChildEnrollment/ChildEnrollment1";
import StepTwo from "./ChildEnrollment/ChildEnrollment2";
import StepThree from "./ChildEnrollment/ChildEnrollment3";
import StepFour from "./ChildEnrollment/ChildEnrollment4";
import StepFive from "./ChildEnrollment/ChildEnrollment5";
import StepSix from "./ChildEnrollment/ChildEnrollment6";
import StepSeven from "./ChildEnrollment/ChildEnrollment7";
import StepEight from "./ChildEnrollment/ChildEnrollment8";
import { useLocation } from "react-router-dom";

import { useEffect } from "react";
import axios from 'axios';
import { BASE_URL } from "../components/App";
import { useParams } from 'react-router-dom';

function ChildEnrollment() {
  let { childId, parentId } = useParams();
  const [selectedFranchisee, setSelectedFranchisee] = useState();

  //state for steps
  const [step, setstep] = useState(1);

  // function for going to next step by increasing step state by 1
  const nextStep = () => {
    setstep(step + 1);
  };

  // function for going to previous step by decreasing step state by 1
  const prevStep = () => {
    setstep(step - 1);
  };

  // handling form input data by taking onchange value and updating our previous form data state
  const handleInputData = input => e => {
    // input value from the form
    const { value } = e.target;

  }

  const updateStepFromDatabase = async () => {
    let parentId = localStorage.getItem('enrolled_parent_id');
    let token = localStorage.getItem('token');

    let response = await axios.get(`${BASE_URL}/enrollment/parent/child/${parentId}`, {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    });

    if (response.status === 200 && response.data.status === "success") {
      let { childData } = response.data;
      let form_step = childData[0].form_step || 1;

      if (localStorage.getItem('asked_for_consent') === "true") {
        setstep(1);
      } else {
        const query = new URL(window.location.href);

        setstep(parseInt(query.searchParams.get('page')) || form_step);
      }
    } else {
      setstep(1);
    }
  };

  useEffect(() => {
  }, [step])

  useEffect(() => {
    updateStepFromDatabase();
  }, []);

  useEffect(() => {
    if (childId && parentId) {
      localStorage.setItem('enrolled_child_id', childId);
      localStorage.setItem('enrolled_parent_id', parentId);
    }
  }, []);


  const getView = () => {
    return (
      <div id="main">
        <section className="mainsection">
          <Container>
            <div className="admin-wrapper">
              <aside className="app-sidebar"> <LeftNavbar /> </aside>
              <div className="sec-column">
                {step != 1 && <TopHeader selectedFranchisee={selectedFranchisee} setSelectedFranchisee={setSelectedFranchisee} />}
                <div className="entry-container">
                  <header className="title-head">
                    <h1 className="title-lg">Child Enrolment Form</h1>
                  </header>
                  <div className="enrollment-form-sec">
                    {step == 1 && <StepOne nextStep={nextStep} handleFormData={handleInputData} />}
                    {step == 2 && <StepTwo nextStep={nextStep} prevStep={prevStep} handleFormData={handleInputData} />}
                    {step == 3 && <StepThree nextStep={nextStep} prevStep={prevStep} handleFormData={handleInputData} />}
                    {step == 4 && <StepFour nextStep={nextStep} prevStep={prevStep} handleFormData={handleInputData} />}
                    {step == 5 && <StepFive nextStep={nextStep} prevStep={prevStep} handleFormData={handleInputData} />}
                    {step == 6 && <StepSix nextStep={nextStep} prevStep={prevStep} handleFormData={handleInputData} />}
                    {step == 7 && <StepSeven nextStep={nextStep} prevStep={prevStep} handleFormData={handleInputData} />}
                    {step == 8 && <StepEight nextStep={nextStep} prevStep={prevStep} handleFormData={handleInputData} />}
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </section>
      </div>
    );
  }

  return (
    <>{getView()}</>
  )
}

export default ChildEnrollment;
